import { analytics, logEvent } from '../firebase'
import mixpanel from 'mixpanel-browser'

const MIXPANEL_TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN
let mixpanelInitialized = false

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV === 'development',
    track_pageview: false,
    persistence: 'localStorage'
  })
  mixpanelInitialized = true
}

function trackEvent(eventName, params = {}) {
  // GA4
  try {
    logEvent(analytics, eventName, params)
  } catch (e) {
    console.warn('GA4 logEvent failed:', e)
  }

  // Mixpanel
  if (mixpanelInitialized) {
    try {
      mixpanel.track(eventName, params)
    } catch (e) {
      console.warn('Mixpanel track failed:', e)
    }
  }
}

function identifyUser(user, profile = {}) {
  if (!mixpanelInitialized || !user) return

  try {
    mixpanel.alias(user.uid)
  } catch (e) {
    // alias throws if already called for this pair — safe to ignore
  }

  mixpanel.identify(user.uid)
  mixpanel.people.set({
    $name: profile.customDisplayName || user.displayName || '',
    $email: user.email || '',
    isPremium: profile.isPremium || false,
    createdAt: profile.createdAt || ''
  })
}

function resetUser() {
  if (!mixpanelInitialized) return
  mixpanel.reset()
}

function setUserProperties(properties) {
  if (!mixpanelInitialized) return
  mixpanel.people.set(properties)
}

function trackPageView(routeName, params = {}) {
  trackEvent('page_view', { page_name: routeName, ...params })
}

function createAnalyticsEmitter() {
  return (eventName, params) => trackEvent(eventName, params)
}

export function useAnalytics() {
  return {
    trackEvent,
    identifyUser,
    resetUser,
    setUserProperties,
    trackPageView,
    createAnalyticsEmitter
  }
}
